import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';

// services
import { AuthService } from '../../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
         private authService: AuthService
        ) { }

    canActivate() {
        if (this.authService.isAuthenticated()) {
            return true;
        }
        this.router.navigate(['/auth/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/app/shared/guards/auth/auth.guard.ts